module.exports = __webpack_public_path__ + "img/congratulations.d9168f34.png";